import type { IAggFunc, IAggFuncParams } from 'ag-grid-community';
import { csvTextAggFunc } from './csvTextAggFunc';
import { equalityAggFunc } from './equalityAggFunc';
import { latestTimestampAggFunc } from './latestTimestampAggFunc';
import { maxSizeAggFunc } from './maxSizeAggFunc';
import { pmsWarningAggFunc } from './pmsWarningAggFunc';
import { priceAggFunc } from './priceAggFunc';
import { sizeAggFunc } from './sizeAggFunc';
import { sizedAvgAggFunc } from './sizedAvgAggFunc';
import { sumAggFunc } from './sumAggFunc';
import { uniformSizeAggFunc } from './uniformSizeAggFunc';
import { warningAggFunc } from './warningAggFunc';

export const BlotterAggFunc = {
  BuyingPower: 'talosBuyingPower',
  CsvText: 'talosCsvText',
  Equality: 'talosEquality',
  LatestTimestamp: 'talosLatestTimestamp',
  MaxSize: 'talosMaxSize',
  PmsWarning: 'talosPmsWarning',
  Price: 'talosPrice',
  RowCount: 'talosRowCount',
  Size: 'talosSize',
  SizedAvg: 'talosSizedAvg',
  Sum: 'talosSum',
  UniformSize: 'talosUniformSize',
  Warning: 'talosWarning',
} as const;

export type BlotterAggFunc = (typeof BlotterAggFunc)[keyof typeof BlotterAggFunc];

const rowCountAggFunc: IAggFunc<unknown, number> = ({ values }: IAggFuncParams<unknown, number>) => {
  return values.reduce((total: number, value: number | null) => {
    if (value == null) {
      return total;
    }
    return total + value;
  }, 0);
};

const buyingPowerAggFunc: IAggFunc = ({ values, ...params }) => {
  const stringNumericValues = values.map(value => (typeof value === 'string' ? value : value?.max));
  return sumAggFunc({ values: stringNumericValues, ...params });
};

export const DEFAULT_BLOTTER_AGG_FUNCS: Record<BlotterAggFunc, IAggFunc> = {
  [BlotterAggFunc.BuyingPower]: buyingPowerAggFunc,
  [BlotterAggFunc.CsvText]: csvTextAggFunc,
  [BlotterAggFunc.Equality]: equalityAggFunc,
  [BlotterAggFunc.LatestTimestamp]: latestTimestampAggFunc,
  [BlotterAggFunc.MaxSize]: maxSizeAggFunc,
  [BlotterAggFunc.PmsWarning]: pmsWarningAggFunc,
  [BlotterAggFunc.Price]: priceAggFunc,
  [BlotterAggFunc.RowCount]: rowCountAggFunc,
  [BlotterAggFunc.Size]: sizeAggFunc,
  [BlotterAggFunc.SizedAvg]: sizedAvgAggFunc,
  [BlotterAggFunc.Sum]: sumAggFunc,
  [BlotterAggFunc.UniformSize]: uniformSizeAggFunc,
  [BlotterAggFunc.Warning]: warningAggFunc,
};
